import { Component, ElementRef, OnInit, QueryList, ViewChildren  } from '@angular/core';
import cardTypeData from 'src/assets/rewardscalc.json';

@Component({
  selector: 'app-rewards-calculator',
  templateUrl: './rewards-calculator.component.html',
  styleUrls: ['./rewards-calculator.component.css']
})
export class RewardsCalculatorComponent implements OnInit {

availabletrip: number = 0;
remainingMiles: number = 0; 
selectedTabIndex: number = 0;
milesEarned: number | null = null;
milesYouEarned: number | null = null;
totalAnnualExpense = 0;
milesNeeded: number | null = null;
milesPricing: number | null = null;
enterMiles: number = 0;
formattedEnterMiles: string = '0';
totalSavingsMiles: number = 0;
cardFeesPa: number | null = null;
netSavingsMiles: number = 0;
netSavingsBusiness: number = 0;
interestAmount: number = 0;
cashbackAmount: number = 0;
netSavingsCashback: number = 0;
totalsavingbusiness: number = 0;
costPercent: number | null = null;

currencySuffix: string = '';
selectedCountry: string = '';
selectedCardType: string = '';
selectedCardTypeKey: string = '';
selectedCardTypeValue: string = '';
selectedCard: string = '';
selectedAirline: string = '';
selectedClass: string = 'Economy';
selectedTrip: string = '';
tripDetails: string | null = null;
borrowingRate: string = '1';
cashbackRate: string = '0';
selectedPeriod = 'Monthly';

cardTypes: string[] = [];
typeOptions: string[] = [];
cardList: string[] = [];
airlinesList: string[] = [];
tripList: string[] = [];

miles: boolean = true; 
cashback: boolean = false;

countries = [
  { name: 'Singapore', value: 'SG', emoji: '🇸🇬' },
  { name: 'Hong Kong', value: 'HK', emoji: '🇭🇰' },
  { name: 'Australia', value: 'AU', emoji: '🇦🇺' }
];

expenseFields: { label: string; value: number }[] = [
  { label: 'Rent', value: 0 },
  { label: 'Property Maintenance Fees', value: 0 },
  { label: 'Taxes', value: 0 },
  { label: 'Insurance', value: 0 },
  { label: 'Salary - Staff', value: 0 },
  { label: 'Renovation', value: 0 },
  { label: 'Tuition', value: 0 },
  { label: 'Supplier Payment', value: 0 },
  { label: 'Others', value: 0 }
];



typeValueMap: { [key: string]: string } = {};
cardTypesRaw: any[] = [];
allCards: { [key: string]: string[] } = {};
airlineData: any = cardTypeData['Airlines'];

previousPeriod: 'Monthly' | 'Yearly' = 'Monthly'; // default

Math = Math;

@ViewChildren('inputField') inputFields!: QueryList<ElementRef>;



ngOnInit(): void {

  this.expenseFields.forEach(field => {
    if (field.value == null) {
      field.value = 0;
    }
  });
  this.cardTypes = cardTypeData['Card Type'] || [];
  this.selectedCountry = 'Singapore';
  this.updateCurrencySuffix();
  this.cardTypesRaw = cardTypeData.Type;
  this.allCards = cardTypeData.cards;
  const typeArray = cardTypeData.Type;

  this.typeOptions = [];
  this.typeValueMap = {};

  typeArray.forEach((obj: any) => {
    const key = Object.keys(obj)[0];
    const value = obj[key];
    if (!this.typeOptions.includes(key)) {
      this.typeOptions.push(key);
    }
    this.typeValueMap[key] = value;
  });

  this.cardTypesRaw.forEach((item: any) => {
    const key = Object.keys(item)[0];
    const value = item[key];
    if (!this.typeOptions.includes(key)) {
      this.typeOptions.push(key);
    }
    this.typeValueMap[key] = value;
  });

  const firstKey = Object.keys(this.typeValueMap)[0];
  if (firstKey) {
    this.onCardTypeChange(firstKey); // Sets selectedCard & triggers onCardChange
  }

  this.updateCardList();
  this.updateAirlinesList();
  this.updateTripList();
  this.onPeriodChange();

  // Ensure calculations are triggered after default expense is set
  setTimeout(() => {
    this.onCardChange(this.selectedCard); // Recalculate with all data available
  }, 0);
}

onKeyDown(event: KeyboardEvent, index: number): void {
  const inputs = document.querySelectorAll('.input-wrapper input');
  const totalInputs = inputs.length;
  const columns = 3; // You have 3 columns

  const input = inputs[index] as HTMLInputElement;

  // Allow only numbers and navigation keys
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Enter', 'Return'];
  if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
    event.preventDefault();
    return;
  }

  switch (event.key) {
    case 'ArrowRight':
      if (input.selectionEnd === input.value.length) {
        event.preventDefault();
        const nextIndex = (index + 1) % totalInputs; // wrap around to 0
        const nextInput = inputs[nextIndex] as HTMLInputElement;
        if (nextInput) nextInput.focus();
      }
      break;

    case 'ArrowLeft':
      if (input.selectionStart === 0) {
        event.preventDefault();
        const prevIndex = (index - 1 + totalInputs) % totalInputs; // wrap around to last
        const prevInput = inputs[prevIndex] as HTMLInputElement;
        if (prevInput) prevInput.focus();
      }
      break;

    case 'ArrowDown':
      event.preventDefault();
      const downIndex = index + columns;
      if (downIndex < totalInputs) {
        const downInput = inputs[downIndex] as HTMLInputElement;
        if (downInput) downInput.focus();
      }
      break;

    case 'ArrowUp':
      event.preventDefault();
      const upIndex = index - columns;
      if (upIndex >= 0) {
        const upInput = inputs[upIndex] as HTMLInputElement;
        if (upInput) upInput.focus();
      }
      break;

    case 'Enter':
    case 'Return':
      event.preventDefault();
      const enterNextIndex = (index + 1) % totalInputs; // wrap around
      const enterNextInput = inputs[enterNextIndex] as HTMLInputElement;
      if (enterNextInput) enterNextInput.focus();
      break;

    case 'Tab':
      // Default behavior okay (optional to control)
      break;
  }
}



onCountryChange(): void {

  this.updateCurrencySuffix();

  // Your existing logic
  this.updateAirlinesList();
  this.updateTripList();

  const firstKey = Object.keys(this.typeValueMap)[0];
  if (firstKey) {
    this.onCardTypeChange(firstKey);
  }

  this.fetchMilesInfo();
  this.calculateInterestAmount();
  this.calculateTotalSavingsMiles();
  this.calculateTotalSavingBusiness();
  this.calculateCardFees();
  this.calculateNetSavings();
  this.calculateAvailableTrip();
}


updateCurrencySuffix(): void {
  switch (this.selectedCountry) {
    case 'Singapore':
      this.currencySuffix = 'SGD';
      break;
    case 'Hong Kong':
      this.currencySuffix = 'HKD';
      break;
    case 'Australia':
      this.currencySuffix = 'AUD';
      break;
    default:
      this.currencySuffix = '';
  }
}


  updateCardList(): void {
    // Ensure lookupKey matches the structure in this.allCards
    const lookupKey = `${this.selectedCountry} ${this.selectedCardTypeValue}`;
    console.log('Selected country:', this.selectedCountry);
    console.log('Selected card type value:', this.selectedCardTypeValue);
    console.log('Lookup key:', lookupKey);
    
    this.cardList = this.allCards[lookupKey] || [];
    if (this.cardList.length === 0) {
      console.log('No cards found for the selected combination.');
    }
  }

  onCardTypeChange(key: string): void {
    this.selectedCardTypeKey = key;
    this.selectedCardTypeValue = this.typeValueMap[key];
  
    this.updateCardList();
  
    // If the current selectedCard is still valid in the new card list, keep it.
    if (this.cardList.includes(this.selectedCard)) {
      this.onCardChange(this.selectedCard);
    } else if (this.cardList.length > 0) {
      // If not, fallback to first available card
      this.selectedCard = this.cardList[0];
      this.onCardChange(this.selectedCard);
    } else {
      // No cards available for this type
      this.selectedCard = null;
    }
  }
  

    
  onCardChange(card: string) {
    // Find the card data based on the card name
    const match = (cardTypeData as any).earnrate.find((entry: any) => entry.card === card);
    
    // Check if the card has the "miles" property set to false
    this.miles = match ? match.miles : true; // Set miles to false if it's explicitly false in the card data

    this.cashback = match ? match.cashback : false;
  
    // Handle the milesEarned based on card selection
    this.milesEarned = match ? parseFloat(match.milesEarned) : null;
  
    // Make sure enterMiles is treated as a number (default to 0 if empty or NaN)
    const enteredMiles = isNaN(Number(this.enterMiles)) ? 0 : Number(this.enterMiles);
  
    // Calculate milesYouEarned including enterMiles
    if (this.milesEarned !== null && this.totalAnnualExpense) {
      this.milesYouEarned = (this.totalAnnualExpense * this.milesEarned) + enteredMiles;
    } else {
      this.milesYouEarned = enteredMiles;
    }
  
    // Log miles value for debugging
    console.log('Miles:', this.miles);
  
    // Call the other necessary methods
    this.fetchMilesInfo();
    this.calculateInterestAmount();
    this.calculateTotalSavingsMiles();
    this.calculateTotalSavingBusiness();
    this.calculateCardFees();
    this.calculateNetSavings();
    this.calculateAvailableTrip();
  }
    

  selectTab(index: number): void {
    this.selectedTabIndex = index;
  }

  formatInput(value: string, field: any) {
    const numeric = value.replace(/[^0-9]/g, '');
    const withCommas = numeric.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    field.value = withCommas;
  }  

  // Function to update airline dropdown based on selected country
  updateAirlinesList(): void {
    const airlinesByCountry = this.airlineData[this.selectedCountry];
  
    if (airlinesByCountry) {
      this.airlinesList = Object.keys(airlinesByCountry); // should be just one airline per country
      this.selectedAirline = this.airlinesList[0];
    } else {
      this.airlinesList = [];
      this.selectedAirline = '';
    }
  }

  updateTripList(): void {
    const classTrips =
      this.airlineData[this.selectedCountry]?.[this.selectedAirline]?.['class']?.[this.selectedClass];
  
    if (classTrips) {
      this.tripList = Object.keys(classTrips); // e.g., ["SIN-BOM", "SIN-DEL"]
  
      // Preserve selected trip if it exists in new trip list
      if (this.tripList.includes(this.selectedTrip)) {
        // keep current selectedTrip
      } else {
        this.selectedTrip = this.tripList[0]; // fallback to first trip
      }
    } else {
      this.tripList = [];
      this.selectedTrip = '';
    }
  }
  

  
  onEnterMilesChange(event: any): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
  
    // Remove commas and non-digit characters
    const digitsOnly = value.replace(/[^0-9]/g, '');
  
    if (digitsOnly) {
      this.enterMiles = Number(digitsOnly);
      this.formattedEnterMiles = this.formatWithCommas(digitsOnly);
    } else {
      this.enterMiles = 0;
      this.formattedEnterMiles = '0';
    }
  
    const enteredMiles = this.enterMiles;
  
    if (this.milesEarned !== null && this.totalAnnualExpense) {
      this.milesYouEarned = (this.totalAnnualExpense * this.milesEarned) + enteredMiles;
    } else {
      this.milesYouEarned = enteredMiles;
    }
  
    this.fetchMilesInfo();
    this.calculateInterestAmount();
    this.calculateTotalSavingsMiles();
    this.calculateTotalSavingBusiness();
    this.calculateCardFees();
    this.calculateNetSavings();
    this.calculateAvailableTrip();
  
    // 👉 Move cursor to end after formatting
    setTimeout(() => {
      const length = input.value.length;
      input.setSelectionRange(length, length);
    }, 0);
  }


  onAirlineChange(): void {
    this.updateTripList();
  }

  selectClass(className: 'Economy' | 'Business') {
    this.selectedClass = className;
    this.updateTripList();
    this.onTripChange();
  }
  
  onTripChange(): void {
    console.log('Trip changed to:', this.selectedTrip);
    this.fetchMilesInfo();
    this.calculateInterestAmount();
    this.calculateTotalSavingsMiles();
    this.calculateTotalSavingBusiness();
    this.calculateCardFees();
    this.calculateNetSavings();
    this.calculateAvailableTrip(); 
  }

  // Recalculate total if yearly is selected
  calculateTotalIfYearly(): void {
    let sum = 0;
  
    this.expenseFields.forEach(field => {
      const rawValue = field.value?.toString().replace(/,/g, '');
      const numericValue = parseFloat(rawValue) || 0;
  
      // ✅ Multiply each field by 12 if Monthly is selected
      const adjusted = this.selectedPeriod === 'Monthly' ? numericValue * 12 : numericValue;
  
      sum += adjusted;
    });
  
    this.totalAnnualExpense = sum;
  }



onAmountChange(value: string, field: any): void {
  if (!field.touched) field.touched = true;

  // Keep only digits
  const digitsOnly = value.replace(/[^0-9]/g, '');

  if (digitsOnly) {
    field.value = this.formatWithCommas(digitsOnly);
  } else {
    field.value = '0';
    field.touched = false;
  }

  this.onInputChange();
}



formatWithCommas(value: string): string {
  const parts = value.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

// Triggered on every input change
onInputChange(): void { 
  console.log('onInputChange called');
  let sum = 0;

  // Calculate total annual expense
  this.expenseFields.forEach(field => {
    const rawValue = field.value?.toString().replace(/,/g, '');
    const numericValue = parseFloat(rawValue);

    if (!isNaN(numericValue)) {
      const adjusted = this.selectedPeriod === 'Monthly' ? numericValue * 12 : numericValue;
      sum += adjusted;
    }
  });

  this.totalAnnualExpense = sum;

  console.log('Total Annual Expense:', this.totalAnnualExpense);

  // Calculate milesYouEarned considering the input value for enterMiles
  this.milesYouEarned = this.milesEarned 
    ? this.totalAnnualExpense * Number(this.milesEarned) + this.enterMiles 
    : this.enterMiles;

  
    this.fetchMilesInfo();
    this.calculateInterestAmount();
    this.calculateTotalSavingsMiles();
    this.calculateTotalSavingBusiness();
    this.calculateCardFees();
    this.calculateNetSavings();
    this.calculateAvailableTrip();
    this.calculateCashbackAmount();
}


restrictToNumbersOnly(event: KeyboardEvent): void {
  const key = event.key;
  // Check if the key pressed is a number or special key (like backspace, arrow keys)
  if (!/^[0-9]$/.test(key) && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key)) {
    event.preventDefault(); // Prevent input if it's not a number or allowed key
  }
}


onPeriodChange() {
  this.expenseFields = this.expenseFields.map(field => {
    let rawValue = field.value?.toString().replace(/,/g, '') || '0'; // remove commas
    let valueNum = parseFloat(rawValue); // safely parse

    if (this.previousPeriod === 'Yearly' && this.selectedPeriod === 'Monthly') {
      valueNum = valueNum / 12;
    } else if (this.previousPeriod === 'Monthly' && this.selectedPeriod === 'Yearly') {
      valueNum = valueNum * 12;
    }

    return {
      ...field,
      value: parseFloat(valueNum.toFixed(2)) // keep it number
    };
  });

  this.calculateTotalIfYearly();
  this.previousPeriod = this.selectedPeriod as 'Monthly' | 'Yearly';
}



fetchMilesInfo(): void {
  const result = this.getMilesInfo();

  if (result) {
    this.milesNeeded = result.miles_needed;
    this.milesPricing = result.miles_pricing;
    this.tripDetails = result.trip_details;

    console.log('Fetched miles info:', result);

    // Calculate total savings if milesYouEarned is already available
    if (this.milesYouEarned && this.milesPricing) {
      this.totalSavingsMiles = this.milesYouEarned * this.milesPricing;
    } else {
      this.totalSavingsMiles = 0;
    }
  } else {
    // Reset if no data found
    this.milesNeeded = null;
    this.milesPricing = null;
    this.tripDetails = null;
    this.totalSavingsMiles = 0;
  }
}



calculateTotalSavingsMiles(): void {
  if (this.milesYouEarned && this.milesPricing) {
    this.totalSavingsMiles = this.milesYouEarned * this.milesPricing;
  } else {
    this.totalSavingsMiles = null;
  }
}


getMilesInfo(): { miles_needed: number; miles_pricing: number; trip_details: string } | null {
  try {
    const routeData =
      cardTypeData.Airlines?.[this.selectedCountry]?.[this.selectedAirline]?.class?.[this.selectedClass]?.[this.selectedTrip];

    if (routeData) {
      return {
        miles_needed: routeData.miles_needed,
        miles_pricing: routeData.miles_pricing,
        trip_details: routeData.trip_details
      };
    }
  } catch (e) {
    console.error('Invalid path or missing data:', e);
  }

  return null;
}


calculateCardFees(): void {
  const selectedCard = this.selectedCard;
  const totalExpense = this.totalAnnualExpense;

  const earnRateList = cardTypeData.earnrate;

  const cardData = earnRateList.find(
    (item) => item.card === selectedCard
  );

  if (cardData && totalExpense) {
    this.costPercent = parseFloat(cardData.cost); // ✅ Assign to class property
    this.cardFeesPa = (totalExpense * this.costPercent) / 100;
  } else {
    this.costPercent = null;
    this.cardFeesPa = null;
  }
}


calculateNetSavings(): void {
  let savingsSource: number = 0;

  if (this.selectedCardTypeValue === 'Business') {
    this.netSavingsBusiness = this.totalsavingbusiness - (this.cardFeesPa);

    console.log('Total Saving (Business):', this.totalsavingbusiness);
    console.log('Card Fees (PA):', this.cardFeesPa);
    console.log('Net Savings (Business):', this.netSavingsBusiness);
  } else {
    savingsSource = this.totalSavingsMiles || 0;
    this.netSavingsMiles = this.totalSavingsMiles - (this.cardFeesPa);
  }
}



calculateAvailableTrip(): void {
  if (this.milesYouEarned && this.milesNeeded && this.milesNeeded > 0) {
    const trips = this.milesYouEarned / this.milesNeeded;
    this.availabletrip = Math.floor(trips); // Only full trips
    this.remainingMiles = this.milesYouEarned - (this.availabletrip * this.milesNeeded); // Remaining miles after full trips
  } else {
    this.availabletrip = 0;
    this.remainingMiles = 0;
  }
}

calculateInterestAmount(): void {
  // Check if borrowingRate is empty or invalid
  const rateValue = parseFloat(this.borrowingRate);

  if (isNaN(rateValue) || this.borrowingRate.trim() === '') {
    // If empty or invalid, set interestAmount to 0 or handle the case as needed
    this.interestAmount = 0; // Or you can use a default value
    console.log('Borrowing rate is empty, setting interestAmount to 0');
  } else {
    // Otherwise, calculate normally
    const rate = rateValue / 100;
    const days = 55;
    const dailyRate = (rate * days) / 365;
    
    this.interestAmount = this.totalAnnualExpense * dailyRate;
    console.log('Interest Amount calculated:', this.interestAmount);
  }

  this.calculateTotalSavingBusiness();
  this.calculateNetSavings();
}


calculateTotalSavingBusiness(): void {
  console.log('Interest Amount:', this.interestAmount);
  console.log('Total Savings in Miles:', this.totalSavingsMiles);
  
  this.totalsavingbusiness = (this.interestAmount || 0) + (this.totalSavingsMiles || 0);
}

calculateCashbackAmount(): void {
  if (this.totalAnnualExpense !== null && this.cashbackRate !== null) {
    const rate = parseFloat(this.cashbackRate);
    if (!isNaN(rate)) {
      this.cashbackAmount = (this.totalAnnualExpense * rate) / 100;
    } else {
      this.cashbackAmount = null;
    }
  } else {
    this.cashbackAmount = null;
  }

  this.calculateNetSavingsCashback();
}

calculateNetSavingsCashback(): void {
  if (this.cardFeesPa !== null && this.cashbackAmount !== null) {
    this.netSavingsCashback = this.cashbackAmount - this.cardFeesPa;
  } else {
    this.netSavingsCashback = null;
  }
}




}
